import ComicCard from "./ComicCard";
import { comics } from "@/mocks/comics";

const tracking = ["xinghai-huixiang", "lunhui-zhiyan", "jianming-shanhai", "wudu-shilinglu"]
  .map((id) => comics.find((c) => c.id === id)!)
  .filter(Boolean);

const recommend = ["luori-zhicheng", "jixie-xinzang", "mitang-weiji", "shenhai-qiutu"]
  .map((id) => comics.find((c) => c.id === id)!)
  .filter(Boolean);

export default function Updates() {
  return (
    <section id="updates" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700">
              <i className="ri-equalizer-line"></i> 追更进度
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">追更进度条，实时同步</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              已追作品更新新话，进度条自动刷新并即时提醒。继续阅读一键续更，再也不怕找不到上次看到哪一话。
            </p>
          </div>
          <a
            href="#rank"
            className="whitespace-nowrap rounded-full bg-background-200 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            浏览更多连载
          </a>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-background-50">
          <div className="flex items-center justify-between border-b border-background-200/80 px-5 py-4 md:px-6">
            <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-bookmark-line text-primary-500"></i> 我的追更
            </h3>
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              今日 3 部更新
            </span>
          </div>

          <div className="divide-y divide-background-100 px-5 md:px-6">
            {tracking.map((comic) => {
              const progress = Math.round((comic.latestChapter / comic.totalChapters) * 100);
              return (
                <div key={comic.id} className="flex flex-col gap-4 py-5 sm:flex-row sm:items-center">
                  <div className="flex items-center gap-4">
                    <div className="h-20 w-14 shrink-0 overflow-hidden rounded-lg">
                      <img src={comic.cover} alt={`${comic.title} 追更进度封面`} className="h-full w-full object-cover" />
                    </div>
                    <div className="min-w-0">
                      <h4 className="truncate text-base font-bold text-foreground-950">{comic.title}</h4>
                      <p className="mt-1 text-xs text-foreground-500">
                        已看到第 {comic.latestChapter} 话 · 共 {comic.totalChapters} 话
                      </p>
                      <span className="mt-1.5 inline-flex items-center gap-1 rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-semibold text-secondary-800">
                        <i className="ri-flashlight-fill"></i> 本周 {comic.updateDay} 更新
                      </span>
                    </div>
                  </div>

                  <div className="flex-1">
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <span>更新进度</span>
                      <span className="font-semibold text-primary-600">{progress}%</span>
                    </div>
                    <div className="mt-1.5 h-2.5 w-full overflow-hidden rounded-full bg-background-100">
                      <div
                        className="progress-fill h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-500"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  </div>

                  <a
                    href="#updates"
                    className="shrink-0 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-2 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:self-center"
                  >
                    继续阅读
                  </a>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-12 flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-2xl text-foreground-950">
            <i className="ri-arrow-right-line text-primary-500"></i> 编辑推荐 · 人气连载
          </h3>
        </div>
        <div className="mt-6 grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
          {recommend.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}